/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — this tool inspects existing identifiers. To generate a random UUID, use the random generator. Nothing you paste is uploaded.`)
};

const es_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — esta herramienta inspecciona identificadores existentes. Para generar un UUID aleatorio, usa el generador aleatorio. Nada de lo que pegues se carga.`)
};

const de_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein — dieses Tool untersucht vorhandene Kennungen. Um eine zufällige UUID zu erzeugen, verwenden Sie den Zufallsgenerator. Nichts, was Sie einfügen, wird hochgeladen.`)
};

const nl_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee — dit hulpmiddel inspecteert bestaande identificaties. Om een willekeurige UUID te genereren, gebruik je de willekeurige generator. Niets wat je plakt wordt geüpload.`)
};

const fr_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non — cet outil inspecte les identifiants existants. Pour générer un UUID aléatoire, utilisez le générateur aléatoire. Rien de ce que vous collez n'est téléchargé.`)
};

const it_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — questo strumento ispeziona gli identificatori esistenti. Per generare un UUID casuale, usa il generatore casuale. Nulla di ciò che incolla viene caricato.`)
};

const pt_br2_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — esta ferramenta inspeciona identificadores existentes. Para gerar um UUID aleatório, use o gerador aleatório. Nada que você cole é enviado.`)
};

const pt_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — esta ferramenta inspeciona identificadores existentes. Para gerar um UUID aleatório, utilize o gerador aleatório. Nada do que cola é carregado.`)
};

const ja_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ — このツールは既存の識別子を検査します。ランダム UUID を生成するには、ランダム ジェネレータを使用してください。貼り付けたものはアップロードされません。`)
};

const zh_ud_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会——该工具仅用于检查现有的标识符。若要生成随机 UUID,请使用随机生成器。你粘贴的任何内容都不会被上传。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_faq3_a", locale)
	if (locale === "en") return en_ud_faq3_a(inputs)
	if (locale === "es") return es_ud_faq3_a(inputs)
	if (locale === "de") return de_ud_faq3_a(inputs)
	if (locale === "nl") return nl_ud_faq3_a(inputs)
	if (locale === "fr") return fr_ud_faq3_a(inputs)
	if (locale === "it") return it_ud_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_ud_faq3_a(inputs)
	if (locale === "pt") return pt_ud_faq3_a(inputs)
	if (locale === "ja") return ja_ud_faq3_a(inputs)
	return zh_ud_faq3_a(inputs)
};